module.exports = __webpack_public_path__ + "static/media/fm-icons-Facemouth_logo_large.8c155136.svg";